<template>
    <div class="auth-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="auth-content mask-content" @click.stop>
            <span class="close-icon" @click="closeAuth"></span>
            <div class="title">身份验证</div>
            <div class="auth-tip">根据版署防沉迷及实名相关要求，本平台不向未满18周岁， 提供租售账号相关服务，为了不影响您在平台的服务体验， 请尽快完善个人实名认证。</div>
            <div class="form-wrap">
                <div class="input">
                    <input ref="nameInput" type="text" autocomplete="off" v-model="realName" placeholder="请输入姓名" maxlength="50" />
                    <i class="error-tip" v-show="!isRealName">姓名不符合规范</i>
                </div>
                <div class="input">
                    <input type="text" autocomplete="off" v-model="realId" placeholder="请输入身份证号码" maxlength="18" />
                    <i class="error-tip" v-show="!isRealId">身份证号码不符合格式</i>
                </div>
            </div>
            <div class="auth-btn" @click="submitAuth" :class="{ disabled: !realName.length || !realId.length }">
                <i>立即认证</i>
            </div>
        </div>
    </div>
</template>
<script>
import { setUserAuth } from '@/http/api/user'

export default {
    name: 'AuthDialog',
    data() {
        return {
            nameReg: /^[\u4e00-\u9fa5]+[·]?[\u4e00-\u9fa5]+$/,
            realIdReg: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            isShow: false,
            realName: '',
            realId: '',
            request: false,
            payload: ''
        }
    },
    computed: {
        isRealName: function () {
            if (this.realName) {
                return this.nameReg.test(this.realName)
            } else {
                return true
            }
        },
        isRealId: function () {
            if (this.realId) {
                return this.realIdReg.test(this.realId)
            } else {
                return true
            }
        }
    },
    watch: {
        isShow: function (value) {
            if (value) {
                let mobile = this.$store.state.userInfo.mobile
                if (mobile) {
                    this.$cookies.set(mobile, 1, -1)
                }
                this.initData()
                this.request = false
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('auth-page')
                    this.$refs.nameInput.focus()
                })
            } else {
                this.payload = ''
                // 会员页面需要-->没有实名认证过，进入会员页面
                this.$EventBus.$emit('remove-timeid')
            }
        }
    },
    methods: {
        initData() {
            this.realName = ''
            this.realId = ''
        },
        show(payload) {
            this.payload = payload
            this.isShow = true
            const path = this.$router.currentRoute.path
            if (path == '/vip') {
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 9 })
            }
        },
        submitAuth() {
            if (!this.realName && !this.realId) {
                return this.$Toast.show('请先输入姓名和身份证号码')
            }
            if (!this.nameReg.test(this.realName)) {
                return this.$Toast.show('姓名不符合规范')
            }
            if (!this.realIdReg.test(this.realId)) {
                return this.$Toast.show('身份证号码不符合格式')
            }

            if (this.request) {
                return false
            }
            this.request = true

            const data = {
                realName: this.realName,
                realId: this.realId
            }

            setUserAuth(data)
                .then((res) => {
                    if (res.code == 200) {
                        this.$Toast.show('操作成功', 1000, () => {
                            this.$store.dispatch('userAuthInfoAction', {
                                fn: (type) => {
                                    console.log('Auth-type=======>', type)
                                    if (type == 'create-order') {
                                        this.$EventBus.$emit('create-order')
                                    } else if (type instanceof Function) {
                                        type()
                                    }
                                },
                                type: this.payload
                            })
                            this.request = false
                            this.isShow = false
                        })
                    } else {
                        this.request = false
                        this.$Toast.show(res.msg)
                    }
                })
                .catch((err) => {
                    this.request = false
                })
        },
        closeAuth() {
            this.isShow = false
            const path = this.$router.currentRoute.path
            if (this.payload == 'nothing' || this.payload == 'create-order' || this.payload instanceof Function) {
                return
            }
            if (window.history.length <= 1) {
                this.$router.push('/index')
            } else if (path == '/detail') {
            } else {
                this.$router.back()
            }
        }
    }
}
</script>
<style lang="less" scoped>
.auth-page {
    .auth-content {
        padding-top: 48px;
        width: 600px;
        height: 400px;
        background: url(../../../assets/dialog/login-bg.png) center/100% no-repeat;

        .title {
            color: @color-txt-high;
            font-size: 18px;
            line-height: 18px;
            text-align: center;
            margin-bottom: 21px;
        }

        .auth-tip {
            margin: 0 auto 18px;
            width: 368px;
            color: @color-txt-normal;
            font-size: 14px;
            line-height: 24px;

            span {
                color: @color-txt-high;
                user-select: text;
            }
        }

        .form-wrap {
            .input {
                position: relative;
                margin: 0 auto 26px;
                width: 360px;
                height: 40px;

                input {
                    width: 100%;
                    height: 100%;
                    line-height: 40px;
                    outline: none;
                    padding: 0 20px;
                    color: @color-txt-high;
                    border-radius: 20px;
                    border: none;
                    background: @bg-color-00;
                    font-size: 14px;

                    &::placeholder {
                        color: @color-txt-66;
                    }

                    &:-webkit-autofill {
                        background: @bg-color-00;
                        color: @color-txt-high;
                    }
                    &:-internal-autofill-selected {
                        background: @bg-color-00;
                        color: @color-txt-high;
                    }

                    &:focus {
                        background: url(../../../assets/input-bg.png) center/100% no-repeat;
                    }

                    &.input-code {
                        padding: 0 118px 0 24px;
                    }
                }

                .input-prefix {
                    display: inline-block;
                    color: rgb(239, 252, 255);
                    font-size: 16px;
                    font-weight: bold;
                    margin-right: 16px;
                }

                .error-tip {
                    position: absolute;
                    top: 45px;
                    left: 24px;
                    font-size: 12px;
                    color: #fef563;
                }
            }
        }

        .auth-btn {
            margin: 0 auto;
            font-weight: bold;
            .button-linear();
        }
    }
}
</style>
